import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { TreeNode } from "utils/tree";
import { SpaceWithParentAccessLevel } from "views/Account/Spaces/types";

import { SPACES_LIST_COLUMN_ID } from "../constants";
import SpacesListChildrenCell from "./ChildrenCell";
import SpacesListIdCell from "./IdCell";
import SpacesListInheritEntitiesCell from "./InheritEntitiesCell";
import SpacesListLabelsCell from "./LabelsCell";
import SpacesListNameCell from "./NameCell";
import SpacesListRowActionsCell from "./RowActionsCell";

const SPACES_LIST_CELLS: TableCellPerColumn<TreeNode<SpaceWithParentAccessLevel>> = {
  [SPACES_LIST_COLUMN_ID.NAME]: SpacesListNameCell,
  [SPACES_LIST_COLUMN_ID.CHILDREN]: SpacesListChildrenCell,
  [SPACES_LIST_COLUMN_ID.LABELS]: SpacesListLabelsCell,
  [SPACES_LIST_COLUMN_ID.INHERIT_ENTITIES]: SpacesListInheritEntitiesCell,
  [SPACES_LIST_COLUMN_ID.ID]: SpacesListIdCell,
  [SPACES_LIST_COLUMN_ID.ROW_ACTIONS]: SpacesListRowActionsCell,
};

export default SPACES_LIST_CELLS;
